import React from 'react';
// import { useHistory } from 'react-router';
import { FormattedMessage, useIntl } from 'react-intl';

import { useHandleGenerator } from '../../contexts/RoutesContext';

import Button from '../buttons/Normal';
// import EmailForm from '../forms/Email';

import styles from '../../../styles/pages/form.module.scss';

const propTypes = {};

const defaultProps = {};

const EmailPage = () => {
    const intl = useIntl();
    const handle = useHandleGenerator();
    const next = handle('show');

    // const history = useHistory();
    // const onSuccess = useCallback(() => {
    //     history.push(next);
    // }, [history, next]);

    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.content}>
                    <h1>
                        <FormattedMessage
                            id="content.email.donate"
                            defaultMessage="Faire un don"
                            description="Description"
                        />
                    </h1>
                    <p>
                        <FormattedMessage
                            id="content.email.first"
                            defaultMessage="Le visionnement de la pièce vous est offert gratuitement."
                            description="Description"
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            id="content.email.second"
                            defaultMessage="Si vous le souhaitez, vous pouvez faire un don au NTE* afin de soutenir ses activités en cette période trouble et l’aider à préparer son retour sur scène."
                            description="Description"
                        />
                    </p>
                    <p>
                        <Button
                            href={intl.formatMessage({
                                id: 'content.donateUrl',
                                defaultMessage: '',
                            })}
                            external
                            target="blank"
                            rel="noopener noreferer"
                        >
                            <FormattedMessage
                                id="content.email.donate"
                                defaultMessage="Canadon"
                                description="Description"
                            />
                        </Button>
                    </p>
                    <p>
                        <FormattedMessage
                            id="content.email.third"
                            defaultMessage="D’avance, merci de votre appui!"
                            description="Description"
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            id="content.email.fourth"
                            defaultMessage="Bon visionnement!"
                            description="Description"
                        />
                    </p>

                    <Button href={next}>
                        <FormattedMessage
                            id="content.buttons.start"
                            defaultMessage="Débuter"
                            description="Button label"
                        />
                    </Button>

                    <p className={styles.last}>
                        <small>
                            <FormattedMessage
                                id="content.email.fifth"
                                defaultMessage="*Le Nouveau Théâtre Expérimental (NTE) est un organisme à but non lucratif enregistré. Un reçu fiscal est émis pour chaque don."
                                description="Description"
                            />
                        </small>
                    </p>
                </div>
            </div>
        </div>
    );
};
EmailPage.propTypes = propTypes;
EmailPage.defaultProps = defaultProps;

export default EmailPage;
